import { useMemo, useState } from 'react';
// Models
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
// Hooks
import { useCoverageData } from 'src/hooks/useCoverageData';
// Components
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import { colors } from 'design-system';
import { capitalize } from 'lodash';
import { HelpCircle } from 'react-feather';
import CoverageDetailRow from 'src/components/screens/Quotations/components/IndividualCoverages/CoverageDetailRow';
import { ExemptionCoverageId } from 'src/components/screens/Quotations/components/IndividualCoverages/ExemptionCoverage';
import { ExemptionCoverageModal } from 'src/components/screens/Quotations/components/IndividualCoverages/ExemptionCoverageModal';

type Props = {
  quotation: Quotation;
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
};

const IndividualCoverageResumeCard = ({
  quotation,
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
}: Props): JSX.Element => {
  const [open, setOpen] = useState(false);
  const moneyType = useMemo(
    () => quotation.quotationProfile.typeOfMoney,
    [quotation],
  );

  const { coveragesResume } = useCoverageData({
    unit,
    coverageCatalogResumes,
    coverageCatalogs,
    moneyType,
  });

  return (
    <Box data-testid="individual-coverages-card">
      <ExemptionCoverageModal open={open} setOpen={setOpen} />
      <Grid container justifyContent="space-between">
        <Box display="flex" style={{ gap: '0.5rem' }}>
          <FontAwesomeIcon icon={faShieldCheck} size="2xl" color="#0D2E68" />
          <Typography
            data-testid="title-text"
            style={{ fontSize: '19px', fontWeight: 700 }}
          >
            Coberturas
          </Typography>
        </Box>
      </Grid>
      <Box
        display="flex"
        flexDirection="column"
        marginTop="1rem"
        style={{ gap: '1rem' }}
      >
        {coveragesResume.map((coverage) => {
          if (coverage.code === ExemptionCoverageId) {
            return (
              <Box
                display="flex"
                justifyContent="space-between"
                key={coverage.code}
              >
                <Typography
                  style={{
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  {coverage.name}
                </Typography>
                <Box
                  data-testid="helper-button"
                  style={{ width: '25px', textAlign: 'left' }}
                  onClick={() => setOpen(true)}
                >
                  <IconButton>
                    <HelpCircle color={colors.bright_turquoise} size={24} />
                  </IconButton>
                </Box>
              </Box>
            );
          }
          return (
            <CoverageDetailRow
              key={coverage.code}
              data-testid={`coverages-${coverage.code}`}
              name={capitalize(coverage.name)}
              code={coverage.code}
              value={coverage.value}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default IndividualCoverageResumeCard;
